import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const PhoneIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M9 12.4335C10.2035 12.9937 11.6071 13.373 13.2375 13.4845C13.3801 13.4942 13.5 13.3802 13.5 13.2372L13.5 11.25C13.5 11.1119 13.3881 11.0003 13.2501 10.9996C12.4981 10.9956 11.5438 10.9575 10.686 10.5866C10.5765 10.5392 10.4473 10.5679 10.3742 10.6621L9 12.4335ZM9 12.4335C6.14103 11.1025 4.50627 9.10226 3.56192 6.80722M3.56192 6.80722C3.0382 5.53445 2.72682 4.17102 2.53673 2.7808C2.51636 2.63181 2.63282 2.5 2.7832 2.5L4.75 2.5C4.88807 2.5 4.99988 2.61144 5.0039 2.74945C5.02373 3.42971 5.12395 4.56499 5.41154 5.29956C5.45731 5.41648 5.42213 5.55252 5.31803 5.62274L3.56192 6.80722Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
));
